import React from "react";
import { database, storage } from "../../Firebase/firebase";
import AdminProjectCard from "./AdminProjectCard";

function AdminProjects() {
  const [projects, setProjects] = React.useState([]);
  const imageRef = React.useRef();
  const [uploadState, setUploadState] = React.useState(false);
  const [projectForm, setProjectForm] = React.useState({
    title: "",
    description: "",
    techStack: "",
    type: "",
    features: "",
    responsibilities: "",
    gitLink: "",
    blogLink: "",
    hostLink: "",
  });

  React.useEffect(() => {
    const unsubscribe = database.collection("projects").onSnapshot((docs) => {
      setProjects(docs.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    return () => {
      unsubscribe();
    };
  }, []);
  const handleChange = (e) => {
    setProjectForm({
      ...projectForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {};
    for (let key in projectForm) {
      if (projectForm[key]) {
        payload[key] = projectForm[key];
      }
    }
    if (imageRef.current?.files[0]?.name) {
      if (imageRef.current?.files[0]?.type.includes("image")) {
        setUploadState(true);
        const uploadTask = storage
          .ref(`projects/${imageRef.current.files[0].name}`)
          .put(imageRef.current.files[0]);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
          },
          (error) => {},
          () => {
            storage
              .ref("projects")
              .child(imageRef.current.files[0].name)
              .getDownloadURL()
              .then((url) => {
                database.collection("projects").add({
                  ...payload,
                  image: url,
                  imagePath: imageRef.current.files[0].name,
                });
                setUploadState(false);
              });
          }
        );
      }
    }
  };

  const {
    title,
    description,
    techStack,
    type,
    features,
    responsibilities,
    gitLink,
    blogLink,
    hostLink,
  } = projectForm;
  return (
    <div className="adminProjectsContainer flexBox">
      <div className="addNewProject glass ">
        <form className="projectForm flexBox" onSubmit={handleSubmit}>
          <h1>Add New Project</h1>
          <input
            type="text"
            placeholder="Title"
            name="title"
            required
            onChange={handleChange}
            value={title}
          />
          <input type="file" required ref={imageRef} />
          <textarea
            name="description"
            cols="30"
            rows="3"
            placeholder="Description"
            required
            onChange={handleChange}
            value={description}
          />
          <input
            name="techStack"
            placeholder="Tech Stack"
            required
            onChange={handleChange}
            value={techStack}
          />
          <input
            type="text"
            name="type"
            placeholder="Type"
            required
            onChange={handleChange}
            value={type}
          />
          <textarea
            type="text"
            placeholder="Features"
            name="features"
            onChange={handleChange}
            value={features}
          />
          <textarea
            type="text"
            name="responsibilities"
            placeholder="Responsibilities"
            onChange={handleChange}
            value={responsibilities}
          />
          <input
            type="text"
            name="gitLink"
            placeholder="Git Link"
            required
            onChange={handleChange}
            value={gitLink}
          />
          <input
            type="text"
            name="blogLink"
            placeholder="Blog Link"
            onChange={handleChange}
            value={blogLink}
          />
          <input
            type="text"
            name="hostLink"
            placeholder="Host Link"
            onChange={handleChange}
            value={hostLink}
          />
          <button disabled={uploadState}>SUBMIT</button>
        </form>
      </div>
      <div className="adminProjects scroll flexBox">
        <h1>Projects</h1>
        {projects.map((project) => (
          <AdminProjectCard key={project.id} {...project} />
        ))}
        
      </div>
    </div>
  );
}

export default AdminProjects;
